/**
 * @file
 *
 * This file describes only the 'Action Types' and his 'Actions Creators'
 * https://redux.js.org/docs/basics/Actions.html
 * @author JPablo
 */

/*
* Action Types
*/
import {Afiliacion, Documento, FiltroDocumento, FiltroRecepcionDocumental, MotivoRechazo} from "../modelo/Documento";
import {DocumentoP8} from "../modelo/DocumentoP8";

export const CONSULTAR_DOCUMENTOS = "CONSULTAR_DOCUMENTOS";
export const DOCUMENTOS_CONSULTADOS = "DOCUMENTOS_CONSULTADOS";
export const ERROR_CONSULTANDO_DOCUMENTOS = "ERROR_CONSULTANDO_DOCUMENTOS";

export const CONSULTAR_DOCUMENTO_P8 = "CONSULTAR_DOCUMENTO_P8";
export const DOCUMENTO_P8_CONSULTADO = "DOCUMENTO_P8_CONSULTADO";
export const ERROR_CONSULTANDO_DOCUMENTO_P8 = "ERROR_CONSULTANDO_P8";

export const APROBAR_DOCUMENTOS = "APROBAR_DOCUMENTOS";
export const DOCUMENTOS_APROBADOS = "DOCUMENTOS_APROBADOS";
export const ERROR_APROBANDO_DOCUMENTOS = "ERROR_APROBANDO_DOCUMENTOS";

export const ANULAR_DOCUMENTOS = "ANULAR_DOCUMENTOS";
export const DOCUMENTOS_ANULADOS = "DOCUMENTOS_ANULADOS";
export const ERROR_ANULANDO_DOCUMENTOS = "ERROR_ANULANDO_DOCUMENTOS";

export const RECHAZAR_DOCUMENTOS = "RECHAZAR_DOCUMENTOS";
export const DOCUMENTOS_RECHAZADOS = "DOCUMENTOS_RECHAZADOS";
export const ERROR_RECHAZANDO_DOCUMENTOS = "ERROR_RECHAZANDO_DOCUMENTOS";

export const CONSULTAR_MOTIVOS_RECHAZO = "CONSULTAR_MOTIVOS_RECHAZO";
export const MOTIVOS_RECHAZO_CONSULTADOS = "MOTIVOS_RECHAZO_CONSULTADOS";
export const ERROR_CONSULTANDO_MOTIVOS_RECHAZO = "ERROR_CONSULTANDO_MOTIVOS_RECHAZO";

export const CONSULTAR_AFILIACION = "CONSULTAR_AFILIACION";
export const AFILIACION_CONSULTADA = "AFILIACION_CONSULTADA";
export const ERROR_CONSULTANDO_AFILIACION = "ERROR_CONSULTANDO_AFILIACION";

export const RECIBIR_DOCUMENTOS = "RECIBIR_DOCUMENTOS";
export const DOCUMENTOS_RECIBIDOS = "DOCUMENTOS_RECIBIDOS";
export const ERROR_RECIBIENDO_DOCUMENTOS = "ERROR_RECIBIENDO_DOCUMENTOS";

export const ACTUALIZAR_TIPO_DOCUMENTAL = "ACTUALIZAR_TIPO_DOCUMENTAL";
export const TIPO_DOCUMENTAL_ACTUALIZADO = "TIPO_DOCUMENTAL_ACTUALIZADO";
export const ERROR_ACTUALIZANDO_TIPO_DOCUMENTAL = "ERROR_ACTUALIZANDO_TIPO_DOCUMENTAL";

export const LIMPIAR_MENSAJES_DOCUMENTOS = "LIMPIAR_MENSAJES_DOCUMENTOS";

export const VALIDAR_ASIGNACION = "VALIDAR_ASIGNACION";
export const VALIDACION_FINALIZADA = "VALIDACION_FINALIZADA";

export const APROBAR_DOCUMENTOS_COMERCIAL = "APROBAR_DOCUMENTOS_COMERCIAL";
export const DOCUMENTOS_COMERCIAL_APROBADOS = "DOCUMENTOS_COMERCIAL_APROBADOS";
export const ERROR_APROBANDO_DOCUMENTOS_COMERCIAL = "ERROR_APROBANDO_DOCUMENTOS_COMERCIAL";

export const CONSULTAR_DOCUMENTOS_COMERCIAL = "CONSULTAR_DOCUMENTOS_COMERCIAL";
export const DOCUMENTOS_CONSULTADOS_COMERCIAL = "DOCUMENTOS_CONSULTADOS_COMERCIAL";
export const ERROR_CONSULTANDO_DOCUMENTOS_COMERCIAL = "ERROR_CONSULTANDO_DOCUMENTOS_COMERCIAL";

export const REPORTAR_DOCUMENTOS_COMERCIAL = "REPORTAR_DOCUMENTOS_COMERCIAL";
export const DOCUMENTOS_COMERCIAL_REPORTADOS = "DOCUMENTOS_COMERCIAL_REPORTADOS";
export const ERROR_REPORTANDO_DOCUMENTOS_COMERCIAL = "ERROR_REPORTANDO_DOCUMENTOS_COMERCIAL";

/*
* Actions Creators
* Note that's a good practice type the Action fields {..., name: name} instead of {..., name}
*/
export const consultarDocumentos = (filtroDocumento: FiltroDocumento) => ({type: CONSULTAR_DOCUMENTOS, filtroDocumento});
export const documentosConsultados = (documentos: Array<Documento>,paginas: number) => ({type: DOCUMENTOS_CONSULTADOS, documentos, paginas});
export const errorConsultandoDocumentos = () => ({type: ERROR_CONSULTANDO_DOCUMENTOS});
export const consultarMotivosRechazo = () => ({type: CONSULTAR_MOTIVOS_RECHAZO});
export const motivosRechazoConsultados = (motivosRechazo: Array<MotivoRechazo>) =>
    ({type: MOTIVOS_RECHAZO_CONSULTADOS, motivosRechazo});
export const errorConsultandoMotivosRechazo = () => ({type: ERROR_CONSULTANDO_MOTIVOS_RECHAZO});

export const aprobarDocumentos = (dni: string, dniAprueba: string, tipoCliente: string) => ({
    type: APROBAR_DOCUMENTOS,
    dni,
    dniAprueba,
    tipoCliente
});
export const documentosAprobados = (dni: string, tipoCliente: string) => ({
    type: DOCUMENTOS_APROBADOS,
    dni,
    tipoCliente
});
export const errorAprobandoDocumentos = () => ({type: ERROR_APROBANDO_DOCUMENTOS});

export const anularDocumentos = (dni: string) => ({
    type: ANULAR_DOCUMENTOS, dni
});
export const documentosAnulados = (dni: string) => ({type: DOCUMENTOS_ANULADOS, dni});
export const errorAnulandoDocumentos = () => ({type: ERROR_ANULANDO_DOCUMENTOS});

export const rechazarDocumentos = (dni: string, dniRechaza: string, tipoCliente: string,
                                   codigosRechazo: Array<MotivoRechazo>) => ({
    type: RECHAZAR_DOCUMENTOS,
    dni,
    dniRechaza,
    tipoCliente,
    codigosRechazo
});
export const documentosRechazados = (dni: string, tipoCliente: string) => ({
    type: DOCUMENTOS_RECHAZADOS,
    dni,
    tipoCliente
});
export const errorRechazandoDocumentos = () => ({type: ERROR_RECHAZANDO_DOCUMENTOS});

export const consultarAfiliacion = (filtro: FiltroRecepcionDocumental) => ({
    type: CONSULTAR_AFILIACION,
    filtro
});
export const afiliacionConsultada = (afiliaciones: Array<Afiliacion>,
                                    paginas: number) => ({type: AFILIACION_CONSULTADA, afiliaciones,paginas});
export const errorConsultandoAfiliacion = () => ({type: ERROR_CONSULTANDO_AFILIACION});

export const recibirDocumentos = (dni: string, tipoCliente: string, oficina: string, dniRecibe: string) => ({
    type: RECIBIR_DOCUMENTOS,
    dni,
    tipoCliente,
    oficina,
    dniRecibe
});
export const documentosRecibidos = () => ({type: DOCUMENTOS_RECIBIDOS});
export const errorRecibiendoDocumentos = () => ({type: ERROR_RECIBIENDO_DOCUMENTOS});

export const consultarDocumentoP8 = (idDocumento: string) => ({type: CONSULTAR_DOCUMENTO_P8, idDocumento});
export const documentoP8Consultado = (documentoP8: DocumentoP8) => ({type: DOCUMENTO_P8_CONSULTADO, documentoP8});
export const errorConsultandoDocumentoP8 = () => ({type: ERROR_CONSULTANDO_DOCUMENTO_P8});

export const actualizarTipoDocumental = (tipoDocumental: string, dni: string, id: string,titulo: string) => ({
    type: ACTUALIZAR_TIPO_DOCUMENTAL,
    tipoDocumental,
    dni,
    id,
    titulo
});
export const tipoDocumentalActualizado = () => ({type: TIPO_DOCUMENTAL_ACTUALIZADO});
export const errorActualizandoTipoDocumental = () => ({type: ERROR_ACTUALIZANDO_TIPO_DOCUMENTAL});

export const limpiarMensajesDocumentos = () => ({type: LIMPIAR_MENSAJES_DOCUMENTOS});
export const validarAsignacion = (dni: string, tipoCliente: string) => ({type: VALIDAR_ASIGNACION, dni, tipoCliente});
export const validacionFinalizada = (dni: string, asignado: boolean, nombreAsesor?: string, tipoCliente?: string) => ({type: VALIDACION_FINALIZADA,dni, asignado, nombreAsesor, tipoCliente});

export const consultarDocumentosComercial = (filtroDocumento: FiltroDocumento) => ({type: CONSULTAR_DOCUMENTOS_COMERCIAL, filtroDocumento});
export const documentosConsultadosComercial = (documentosComercial: Array<Documento>,paginas: number) => ({type: DOCUMENTOS_CONSULTADOS_COMERCIAL, documentosComercial, paginas});
export const errorConsultandoDocumentosComercial = () => ({type: ERROR_CONSULTANDO_DOCUMENTOS_COMERCIAL});

export const aprobarDocumentosComercial = (dni: string, dniAprueba: string, tipoCliente: string) => ({
    type: APROBAR_DOCUMENTOS_COMERCIAL,
    dni,
    dniAprueba,
    tipoCliente
});
export const documentosComercialAprobados = (dni: string, tipoCliente: string) => ({
    type: DOCUMENTOS_COMERCIAL_APROBADOS,
    dni,
    tipoCliente
});
export const errorAprobandoDocumentosComercial = () => ({type: ERROR_APROBANDO_DOCUMENTOS_COMERCIAL});

export const reportarDocumentosComercial = (
        dni: string, 
        dniRechaza: string, 
        tipoCliente: 
        string,codigosRechazo: Array<MotivoRechazo>
    ) => ({
            type: REPORTAR_DOCUMENTOS_COMERCIAL,
            dni,
            dniRechaza,
            tipoCliente,
            codigosRechazo
        }
);
export const documentosComercialReportados = (dni: string, tipoCliente: string) => ({
    type: DOCUMENTOS_COMERCIAL_REPORTADOS,
    dni,
    tipoCliente
});
export const errorReportandoDocumentosComercial = () => ({type: ERROR_REPORTANDO_DOCUMENTOS_COMERCIAL});



// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/modulos/documentosActions.ts